export default "__VITE_ASSET__133ba7d5__"